import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { TeamRole } from 'src/app/core/models/project-pilot.model';
import { Message } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';

@Component({
  selector: 'app-manage-team-role',
  templateUrl: './manage-team-role.component.html',
  styleUrls: ['./manage-team-role.component.scss']
})
export class ManageTeamRoleComponent implements OnInit {
  @Input() role: TeamRole;
  @Input() roles: TeamRole[] = [];
  public privileges: string[] = [];
  public roleForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;


  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService,
    private projectPilotService: ProjectPilotService
  ) { }

  ngOnInit(): void {
    this.privileges = this.projectPilotService.getPrivileges();
    this.setRole(this.role);
  }

  public setRole(role?: TeamRole) {
    if (!role)
      role = {
        id: null,
        name: "",
        privilege: "VIEW",
        description: "",
        disabled: false,
        memberCount: 0
      } as TeamRole;
    this.roleForm = this.fb.group({
      id: this.fb.control(role?.id || null),
      name: this.fb.control(role.name, [Validators.required, Validators.pattern(RegExp.name)]),
      privilege: this.fb.control(role.privilege, [Validators.required]),
      description: this.fb.control(role.description, [Validators.pattern(RegExp.description)]),
      memberCount: this.fb.control(role.memberCount, []),
      disabled: this.fb.control(role.disabled, []),
    });
    this.roleForm.valueChanges.subscribe(value => this.modified = true);
  }

  get r() {
    return this.roleForm.controls;
  }

  public saveRole(inProgress?: any) {
    this.submitted = true;
    if (this.roleForm.valid) {
      const role: TeamRole = this.roleForm.value;
      if (this.roles.some(w => 
        w.name.toLowerCase() === role.name.toLowerCase() && w.id !== role.id)) {
        this.commonService.setToastr(400, `Name already exists.`);
        return;
      }  
      if (!this.modified) {
        this.activeModal.close({ failed: true });
        this.commonService.setToastr(200, `Role updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (role.id) {
        this.projectPilotService.updateTeamRole(role.id, role).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Team Role ${response.message}`);
            } else {
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
            inProgress.value = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      } else {
        this.projectPilotService.createTeamRole(role).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Team ${response.message}`);
            } else {
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
            inProgress.value = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      }
    }
  }
}

